/* eslint-disable import/order */
/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

// IMPORTANT: publicPath must be set before any other module loads.
import './publicPath'

import { isLoginShellPath } from './loginShellPaths'

async function bootstrap() {
  if (isLoginShellPath(window.location.pathname)) {
    await import(/* webpackChunkName: "login" */ './loginBootstrap')
    return
  }

  await import(/* webpackChunkName: "app" */ './appBootstrap')
}

void bootstrap().catch((error) => {
  console.error(`Failed to load application`, error)
})
